import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../contexts/ThemeContext';
import { useNotification } from '../contexts/NotificationContext';

const ToggleButton = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'isDark'
})<{ isDark: boolean }>`
  background: ${props => props.isDark ? 'var(--primary)' : '#dceaf2'};
  border: 1px solid var(--border);
  border-radius: 999px;
  width: 54px;
  height: 30px;
  position: relative;
  cursor: pointer;
  transition: background 0.3s ease;
  flex-shrink: 0;
  z-index: 1;
  
  &:before {
    content: '';
    position: absolute;
    top: 4px;
    left: ${props => props.isDark ? '28px' : '4px'};
    width: 20px;
    height: 20px;
    background: ${props => props.isDark ? '#0f1720' : '#ffffff'};
    border-radius: 50%;
    transition: left 0.3s ease;
  }
  
  &:after {
    content: '${props => props.isDark ? 'D' : 'L'}';
    position: absolute;
    top: 50%;
    left: ${props => props.isDark ? '9px' : '34px'};
    transform: translateY(-50%);
    font-size: 11px;
    font-weight: 700;
    color: ${props => props.isDark ? '#ffffff' : 'var(--text-secondary)'};
    pointer-events: none;
  }
`;

const ThemeToggle: React.FC = () => {
  const { isDark, toggleTheme } = useTheme();
  const { showInfo } = useNotification();

  const handleToggle = () => {
    toggleTheme();
    showInfo(
      `Switched to ${!isDark ? 'dark' : 'light'} mode`,
      'Theme changed'
    );
  };

  return (
    <ToggleButton 
      isDark={isDark} 
      onClick={handleToggle}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    />
  );
};

export default ThemeToggle;
